export const tvs={
    page: 1,
    results: [
      {
        backdrop_path: '/7BzmK4MWc0cj4hCxwWURt6TS6UR.jpg',
        first_air_date: '2023-08-31',
        genre_ids: [16, 10765, 10759, 35],
        id: 131378,
        name: '어드벤처 타임: 피오나와 케이크',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Adventure Time: Fionna & Cake',
        overview: '',
        popularity: 244.518,
        poster_path: '/fi1b6U1kp73xheECzqwzMn8u3mX.jpg',
        vote_average: 9.3,
        vote_count: 117,
      },
      {
        backdrop_path: '/9faGSFi5jam6pDWGNd0p8JcJgXQ.jpg',
        first_air_date: '2008-01-20',
        genre_ids: [18, 80],
        id: 1396,
        name: '브레이킹 배드',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Breaking Bad',
        overview:
          '2008년 1월 AMC에서 방영을 시작한 범죄 스릴러. Breaking Bad는 막가기를 뜻하는 미국 남부 지방의 속어이다. 한때 노벨화학상까지 바라 볼 정도로 뛰어난 과학자였던 고등학교 화학 교사 월터 화이트는 자신의 50세 생일 날에 폐암 3기 진단을 받는다. 어느 날 동서와 함께 마약 단속 현장을 참관한 그는 현장에서 달아나는 옛 제자 제시를 발견한다. 뇌성마비에 걸린 고등학생 아들과 임신한 아내를 위해 제시에게 동업을 제의한 월터는 자신의 화학지식을 이용해 전례없는 고순도 고품질의 메스암페타민을 제조한다.',
        popularity: 427.148,
        poster_path: '/3xnWaLQjelJDDF7LT1WBo6f4BRe.jpg',
        vote_average: 8.9,
        vote_count: 12491,
      },
      {
        backdrop_path: '/rkB4LyZHo1NHXFEDHl9vSD9r1lI.jpg',
        first_air_date: '2021-11-06',
        genre_ids: [16, 18, 10765, 10759],
        id: 94605,
        name: '아케인',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Arcane',
        overview:
          '2021년 11월 Netflix에서 방영을 시작한 애니메이션. 라이엇 게임즈의 League of Legends를 원작으로 한다. 지상 도시 필트오버와 그 아래의 지하 도시 자운. 극심하게 반목하는 두 쌍둥이 도시에서, 두 자매가 서로 반대편에 서서 싸우기에 이른다. 마법 기술과 신념의 충돌 속에서 전쟁이 시작된다.',
        popularity: 189.618,
        poster_path: '/fqldf2t8ztc9aiwn3k6mlX3tvRT.jpg',
        vote_average: 8.7,
        vote_count: 3364,
      },
      {
        backdrop_path: '/4Mt7WHox67uJ1yErwTBFcV8KWgG.jpg',
        first_air_date: '1999-10-20',
        genre_ids: [10759, 35, 16],
        id: 37854,
        name: '원피스',
        origin_country: ['JP'],
        original_language: 'ja',
        original_name: 'ワンピース',
        overview:
          '해적왕을 꿈꾸는 소년 루피와 동료들의 유쾌한 모험담을 그린 작품! 힘있는 연출과 개성있는 그림체 및 캐릭터들의 활기찬 묘사로 인기를 모았으며, 1억 만부 이상 판매된 원작만화의 인기를 바탕으로 다양한 버전으로 제작된 초히트작 애니메이션이다.\n\n˝최고의 해적왕˝을 꿈꾸는 루피와 동료들의 파란만장한 모험담 !\n\n떄는 해적들이 난무하는 ‘춘추전국시대’. 곳곳에서는 전설적인 해적왕 골드로저가 남긴 보물 ‘원피스’를 놓고 수많은 해적들이 서로 싸우고 있었다. 어릴 때부터 골드로저를 너무도 동경한 나머지 자신도 전설의 해적왕이 되는 것이 꿈인 주인공 루피. 그러나 루피는 악마의 열매를 먹은 이후로 몸을 자유자재로 늘일 수 있지만 수영을 할 수가 없는 처지이다. 바다가 주 활동무대인 해적에게 있어 수영은 필수. 그러나 해적왕을 꿈꾸는 루피는 수영을 할 수 없음에도 불구하고 물에 빠지지 않으면 된다면서 자신의 꿈을 향해 모험을 떠난다. 그 과정에서 만나게 되는 현상금 헌터 ‘조로’, 자칭 해적전문 도둑인 ‘나미’, 저격수 ‘우솝, 그리고 주방장 ‘상디’까지. 지금부터 루피와 그의 동료 4명이 함께하는 해적의 꿈을 향한 파란만장한 모험이 펼쳐진다',
        popularity: 250.463,
        poster_path: '/qHjXsSUuolEtbgvYPzRjAuB1VHE.jpg',
        vote_average: 8.7,
        vote_count: 4100,
      },
      {
        backdrop_path: '/8CXw90lEmnJQeUvkgSnl5bEjbQI.jpg',
        first_air_date: '2013-12-02',
        genre_ids: [16, 35, 10765, 10759],
        id: 60625,
        name: '릭 앤 모티',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Rick and Morty',
        overview:
          '술에 절어 사는 천재 과학자 릭은 투정이 심한 10대 손자 모티를 데리고 외계와 대체 현실로 아슬아슬한 모험을 떠난다.',
        popularity: 2247.738,
        poster_path: '/OXy96OFiLDZIz9jT4Byxk1Hk6b.jpg',
        vote_average: 8.7,
        vote_count: 8658,
      },
      {
        backdrop_path: '/A6tMQAo6t6eRFCPhsrShmxZLqFB.jpg',
        first_air_date: '2009-04-05',
        genre_ids: [10759, 16, 10765],
        id: 31911,
        name: '강철의 연금술사 BROTHERHOOD',
        origin_country: ['JP'],
        original_language: 'ja',
        original_name: '鋼の錬金術師 FULLMETAL ALCHEMIST',
        overview:
          '죽은 어머니를 살리기 위해 시도한 금단의 연금술로 인해 신체의 일부와 전부를 빼앗긴 에드워드와 알폰스 형제. 동생 알폰스의 신체를 되찾기 위해 현자의 돌을 찾아나선다. 강철의 연금술사 오리지널판 이후 제작되어 원작 만화를 더욱 충실히 반영한 리메이크 버전이다.',
        popularity: 321.622,
        poster_path: '/9SkrxQDka8JAk8tUwb396prUR9J.jpg',
        vote_average: 8.7,
        vote_count: 1765,
      },
      {
        backdrop_path: '/70YdbMELM4b8x8VXjlubymb2bQ0.jpg',
        first_air_date: '2017-03-19',
        genre_ids: [18, 10751],
        id: 70785,
        name: '빨간 머리 앤',
        origin_country: ['CA'],
        original_language: 'en',
        original_name: 'Anne with an E',
        overview:
          '마음에 불꽃을 품은 여자아이 앤. 나이 든 오누이의 초록 지붕집에 발을 들이게 된다. 커스버트 남매와 낮선 고아 소녀가 가족이 되고 성장하는 과정을 그려낸 시리즈.',
        popularity: 188.668,
        poster_path: '/lKUYNB42aCLYEO7368W5EkjtwAt.jpg',
        vote_average: 8.7,
        vote_count: 4394,
      },
      {
        backdrop_path: '/kU98MbVVgi72wzceyrEbClZmMFe.jpg',
        first_air_date: '2005-02-21',
        genre_ids: [16, 10759, 10765],
        id: 246,
        name: '아바타 아앙의 전설',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Avatar: The Last Airbender',
        overview:
          '물의 부족, 흙의 왕국, 불의 제국, 공기의 유목민은 불의 제국이 일으킨 전쟁으로 평화로운 균형을 잃게 된다. 사람들은 4개의 원소를 모두 다룰 줄 아는 아바타가 나타나 이 세상에 평화를 다시 돌아오기를 기다린다. 물의 부족인 카타라와 소카 남매는 빙하 속에 갇힌 아바타, 공기의 유목민 출신 아앙을 구해준다. 아바타의 운명을 타고난 아앙은 4가지 요소를 다루는 능력을 마스터하고 불의 제국을 물리쳐야 하지만 이 거대한 임무를 감당하는 것이 달갑지 만은 않다. 카타라와 그녀의 용감한 오빠 소카의 도움을 받으며 아앙은 세계를 구하기 위한 위험한 여행을 시작한다.',
        popularity: 77.702,
        poster_path: '/77odCK2vleJcXzFH4mLCMK93ikd.jpg',
        vote_average: 8.7,
        vote_count: 3511,
      },
      {
        backdrop_path: '/nTvM4mhqNlHIvUkI1gVnW6XP7GG.jpg',
        first_air_date: '2019-04-06',
        genre_ids: [16, 10759, 10765],
        id: 85937,
        name: '귀멸의 칼날',
        origin_country: ['JP'],
        original_language: 'ja',
        original_name: '鬼滅の刃',
        overview:
          '2019년 4월 Tokyo MX에서 방영을 시작한 애니메이션. 고토게 코요하루의 동명의 만화를 원작으로 한다. 다이쇼 시대, 가난하지만 가족들과 함께 행복한 일상을 보내던 카마도 탄지로. 설이 오기 전에 숯을 잔뜩 팔아 가족들을 배불리 먹여주고 싶었던 탄지로는 혼자 마을로 내려가 숯을 판다. 다음날이 밝고 집에 도착한 탄지로는 가족들이 처참하게 몰살당한 모습을 보고, 유일하게 살아있던 여동생 네즈코를 구하기 위해 그녀를 의사에게 데려가려 하지만 네즈코는 이미 혈귀가 되어 있었다. 가혹한 운명의 사슬을 끊어내고 세상에서 혈귀를 멸하려, 지금 탄지로가 복수의 칼날을 높이 든다.',
        popularity: 177.077,
        poster_path: '/iR6T6QxSJpSQi1S4GGjGWLQkSva.jpg',
        vote_average: 8.7,
        vote_count: 5652,
      },
      {
        backdrop_path: '/6UH52Fmau8RPsMAbQbjwN3wJSCj.jpg',
        first_air_date: '2021-03-25',
        genre_ids: [16, 10765, 10759, 18],
        id: 95557,
        name: '인빈시블',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Invincible',
        overview:
          '마크 그레이슨은 17살에 슈퍼파워를 물려받자 아버지와 함께 지구에서 가장 위대한 영웅 중 하나가 된다. 드디어 꿈이 이루어졌지만 충격적인 사건이 모든 것을 뒤흔든다.',
        popularity: 331.338,
        poster_path: '/yDWJYRAwMNKbIYT8ZB33qy84uzO.jpg',
        vote_average: 8.7,
        vote_count: 3736,
      },
      {
        backdrop_path: '/hMjvf1xGcCbbobFuM2iYR9Tj0Yr.jpg',
        first_air_date: '2022-04-22',
        genre_ids: [18],
        id: 124834,
        name: '하트스토퍼',
        origin_country: ['GB'],
        original_language: 'en',
        original_name: 'Heartstopper',
        overview:
          '학교에서 만나 친구가 된 찰리와 닉. 우정인 줄만 알았는데 둘 사이에 그 이상의 감정이 싹튼다. 10대들의 학교생활과 풋풋한 사랑을 다룬 성장 드라마 시리즈.',
        popularity: 151.872,
        poster_path: '/p0AtD0ivSlHq2MHY6JFgyhNqAQY.jpg',
        vote_average: 8.7,
        vote_count: 1060,
      },
      {
        backdrop_path: '/jsXKG9uppnPrhqFNhImllyCfLhl.jpg',
        first_air_date: '2016-04-03',
        genre_ids: [10759, 16],
        id: 65930,
        name: '나의 히어로 아카데미아',
        origin_country: ['JP'],
        original_language: 'ja',
        original_name: '僕のヒーローアカデミア',
        overview:
          '가공의 세계가 현실로! 이것은 내가 최고의 히어로가 되기까지의 이야기다. 시작은 중국의 경경 시에서 빛을 내뿜는 아기가 태어났다는 뉴스였다. 이후에 각지에서 초현실적 현상이 발견되고 원인도 밝혀지지 않은 채 세월이 흐른다. 세계 총인구의 80%가 어떤 형태로든 특이체질인 초인사회가 된 현재. 선천적으로 타고난 특별한 힘인 ‘개성’을 악용하는 범죄자 ‘빌런’이 갈수록 늘어난다. 이에 마찬가지로 ‘개성’을 가진 자들이 ‘히어로’로서 빌런과 재해에 맞서며 사람들을 구하는 사회를 확립한다. 일찍이 누구나 상상하며 동경하는 ‘히어로’가 현실이 된 세계에서 미도리야 이즈쿠도 히어로가 되는 것을 꿈꾼다. 유명한 히어로를 다수 배출한 유에이 고교에 입학을 목표로 삼고 있지만 아무런 특이체질도 아닌 ‘무개성’의 낙오자로 절망에 빠진다. 그러던 어느 날, 자신이 가장 동경하는 최고의 히어로 올마이트를 우연히 만난 것을 계기로 운명을 크게 바꾸게 된다. 친구, 스승, 라이벌, 빌런... 가지각색의 인물, 수많은 시련과 마주하면서 미도리야 이즈쿠는 최고의 히어로가 되기 위해 성장해 간다. 신세대의 열띤 히어로 스토리가 지금 시작된다!',
        popularity: 136.309,
        poster_path: '/wiXNjJaSSpnhPPa4N6APqpyVNBy.jpg',
        vote_average: 8.7,
        vote_count: 4523,
      },
      {
        backdrop_path: '/uoA7xBzCt3XXqL5fMmB8pmYgABJ.jpg',
        first_air_date: '2016-12-02',
        genre_ids: [18, 10765, 35],
        id: 67915,
        name: '쓸쓸하고 찬란하神: 도깨비',
        origin_country: ['KR'],
        original_language: 'ko',
        original_name: '쓸쓸하고 찬란하神-도깨비',
        overview:
          '2016년 12월 tvN에서 방영을 시작한 드라마. 도깨비 설화를 모티브로 김은숙 작가가 3년 전부터 기획하였으며 사극과 현대극을 오가는 판타지적인 요소를 강조한 드라마이다. 당신이 세상에서 멀어지고 있을 때 누군가 세상 쪽으로 등을 떠밀어 주었다면, 그건 신이 당신 곁에 머물다 가는 순간이다.불멸의 삶을 끝내기 위해 인간 신부가 필요한 도깨비, 그리고 그와 기묘한 동거를 시작한 기억상실증 저승사자. 그런 그들 앞에 도깨비 신부라 주장하는 죽었어야 할 운명의 소녀가 나타나며 벌어지는 신비로운 낭만 설화.',
        popularity: 86.19,
        poster_path: '/qZMEiTsNlCQV27hHQE27ZtlPWyv.jpg',
        vote_average: 8.7,
        vote_count: 2550,
      },
      {
        backdrop_path: '/uDgy6hyPd82kOHh6I95FLtLnj6p.jpg',
        first_air_date: '2023-01-15',
        genre_ids: [18],
        id: 100088,
        name: '더 라스트 오브 어스',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'The Last of Us',
        overview:
          '정체불명의 팬데믹으로 인류 대다수가 죽거나 괴생명체가 되어버린 근미래,  황량해진 미국을 횡단하는 두 사람의 이야기를 다룬 포스트 아포칼립스물이다.',
        popularity: 429.953,
        poster_path: '/xSwGgk187WVzdlG2DUrYi7BB8mf.jpg',
        vote_average: 8.7,
        vote_count: 4121,
      },
      {
        backdrop_path: '/rqbCbjB19amtOtFQbb3K2lgm2zv.jpg',
        first_air_date: '2013-04-07',
        genre_ids: [10765, 16, 10759],
        id: 1429,
        name: '진격의 거인',
        origin_country: ['JP'],
        original_language: 'ja',
        original_name: '進撃の巨人',
        overview:
          '2013년 4월 MBS에서 방영을 시작한 애니메이션. 100여 년 전 갑자기 나타난 거인들에 의해 멸종 위기에 처한 인류는 거대한 벽을 쌓고 그 안에서 살아가고 있다. 에렌은 바깥 세계를 동경하며, 언젠가 저 방벽 밖으로 나가겠다는 꿈을 키우고 있었다. 그러던 어느 날, 60m가 넘는 초대형 거인의 등장으로 벽은 무너지고, 거인들이 벽 안으로 들어와 사람들을 잡아먹기 시작한다. 절규와 죽음으로 가득한 절망적인 상황에서 거인에게 어머니 카를라를 비롯한 소중한 사람들을 빼앗긴 엘런은 복수를 맹세하고, 사무친 복수심을 원동력으로 삼아 만 12세에 훈련병단의 훈련병으로 지원한다.',
        popularity: 221.041,
        poster_path: '/8Cdl0sJQikHQvgn5wKJZ221Ceve.jpg',
        vote_average: 8.7,
        vote_count: 5529,
      },
      {
        backdrop_path: '/2vbE9ajftJ7dkqUAyxDS0WFILx8.jpg',
        first_air_date: '2010-09-06',
        genre_ids: [16, 35],
        id: 31132,
        name: '레귤러 쇼',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Regular Show',
        overview:
          '큰 어치 모디카이와 아메리카너구리 릭비는 공원지기로 일하는 베스트프렌드 이다. 일은 대충대충하고 어떻게하면 신나게 놀지만 고민하는 것이 그들의 일상. 이 둘은 그들의 보스인 벤슨(검볼 자판기)과 동료인 스킵스(예티)를 항상 화나게 만들어 해고의 위협을 받지만 천진난만한 롤리팝 신사이자, 공원 소유자의 아들인 팝스를 즐겁게 만들어 주기 때문에 절대 해고되지 않는다!',
        popularity: 680.655,
        poster_path: '/mS5SLxMYcKfUxA0utBSR5MOAWWr.jpg',
        vote_average: 8.7,
        vote_count: 1790,
      },
      {
        backdrop_path: '/cHyY5z4txdVyGtYMvBJhCqCcJso.jpg',
        first_air_date: '2020-01-10',
        genre_ids: [16, 10765, 18, 10759, 35],
        id: 92685,
        name: '아울 하우스',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'The Owl House',
        overview:
          '판타지 세상에 심취해 있는 소녀 루스, 픽션과 현실을 구분하지 못 하고 학교에서 사고를 치다 결국 여름방학 3개월을 정신안정 캠프에서 보내는 처벌을 받게 된다. 하지만 캠프로 떠나기 직전, 우연히 자신의 소설책을 들고 낡은 폐가로 들어가는 부엉이를 뒤쫒다 그토록 동경하던 판타지 세계에서 마녀 이다와 만나게 되는데...',
        popularity: 323.472,
        poster_path: '/zhdy3PcNVE15wj1wrxn45ARZBnx.jpg',
        vote_average: 8.7,
        vote_count: 1386,
      },
      {
        backdrop_path: '/900tHlUYUkp7Ol04XFSoAaEIXcT.jpg',
        first_air_date: '2019-05-06',
        genre_ids: [18],
        id: 87108,
        name: '체르노빌',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Chernobyl',
        overview:
          '2019년 5월 HBO에서 방영을 시작한 미니시리즈. 전 세계를 공포로 몰고 가며 인류 최악의 인재로 기록된 구 소련 체르노빌 원자력 발전소 사태를 재구성했다. 1988년 4월 26일 모스크바, 한 남자가 긴 이야기를 마친 뒤 녹음 테이프를 신문지로 감싼다. 남자는 음식물 쓰레기를 버리는 척, 테이프를 숨겨 집 밖으로 나온다. 아직 어둠에 싸인 거리 한쪽에서 수상한 차가 그를 감시 중이다. 음식물 쓰레기통 옆의 폐건물 유리창 안으로 녹음 테이프를 던진 남자는 집으로 돌아와 고양이에게 밥을 준 뒤 목을 맨다. 벽시계의 바늘이 1시 24분을 가리키고 있다.',
        popularity: 185.329,
        poster_path: '/hAxARod0sqPldhbHa6WZebAZMP3.jpg',
        vote_average: 8.7,
        vote_count: 5410,
      },
      {
        backdrop_path: '/hPea3Qy5Gd6z4kJLUruBbwAH8Rm.jpg',
        first_air_date: '2015-02-08',
        genre_ids: [80, 18],
        id: 60059,
        name: '베터 콜 사울',
        origin_country: ['US'],
        original_language: 'en',
        original_name: 'Better Call Saul',
        overview:
          '2015년 2월 AMC에서 방영을 시작한 드라마. 브레이킹 배드의 스핀오프 시리즈이다. 브레이킹 배드의 범죄 변호사였던 사울 굿맨의 6년 전 과거인 2002년. 그는 지미 맥길이라는 본명으로 국선 변호사로서 활동하고 있다. 일류 변호사인 형과의 갈등, 과거 시세로에서 사기꾼으로 살던 시절의 기억, 그리고 삼류 변호사가 겪는 어려움들이 지미를 선택의 기로에 계속 내몰게 되며 그 갈림길에서 준법과 불법, 도덕과 이기심 등을 놓고 끊임없이 갈등한다. 그리고 점점 타락해간다.',
        popularity: 476.605,
        poster_path: '/fC2HDm5t0kHl7mTm7jxMR31b7by.jpg',
        vote_average: 8.6,
        vote_count: 4407,
      },
      {
        backdrop_path: '/zbBNp4djy9dGOfMzVBQoP1ZAdET.jpg',
        first_air_date: '2017-06-19',
        genre_ids: [35, 10751],
        id: 72637,
        name: 'Once',
        origin_country: ['AR'],
        original_language: 'es',
        original_name: 'O11CE',
        overview: '',
        popularity: 69.744,
        poster_path: '/zbVwpFNma4RV7HkIVT3aOUmGUJf.jpg',
        vote_average: 8.6,
        vote_count: 1365,
      },
    ],
    total_pages: 153,
    total_results: 3051,
  };